import {isJavascriptMimeType} from '../../../utils/mime'
import {CMS_SCRIPTS_MIME_TYPE} from '../../../constants'
import {parseFragment, serialize} from 'parse5'

function walk(documentFragment, fn) {
    for (let node of documentFragment.childNodes) {
        fn(node)
        if (node.childNodes) {
            walk(node, fn)
        }
    }
}

const convertScript = (node) => {
    // ignore non script tags
    if (node.tagName?.toLowerCase() !== 'script') {
        return
    }
    node.attrs = node.attrs || []
    // ignore non javascript script tags
    if (
        node.attrs.some(({name, value}) => {
            if (name !== 'type') return false
            const validScript = isJavascriptMimeType(value)
            return !validScript
        })
    ) {
        return
    }

    node.attrs = node.attrs.filter(({name}) => name !== 'type')
    node.attrs.push({
        name: 'type',
        value: CMS_SCRIPTS_MIME_TYPE
    })
}

const convertSkImage = (node) => {
    // if doesn't have .sk-image class, ignore
    if (
        !node.attrs?.some(
            ({name, value}) => name === 'class' && value.split(' ').includes('sk-image')
        )
    ) {
        return
    }

    // walk the child nodes and convert data-srcset and data-src to srcset and src
    node.childNodes.forEach((child) => {
        child.attrs?.forEach((attr) => {
            if (attr.name === 'data-srcset') {
                attr.name = 'srcset'
            }
            if (attr.name === 'data-src') {
                attr.name = 'src'
            }
            return attr
        })
    })
}

// convert css links to pwa-widget-stylesheet so they load async without blocking the page rendering
const convertCssLinks = (node) => {
    // ignore non link tags
    if (node.tagName?.toLowerCase() !== 'link') {
        return
    }

    node.attrs = node.attrs || []
    // ignore non css link tags
    if (!node.attrs.some(({name, value}) => name === 'rel' && value === 'stylesheet')) {
        return
    }

    node.nodeName = 'pwa-widget-stylesheet'
    node.tagName = 'pwa-widget-stylesheet'
}

// add loading=lazy to image
const setImageLoadingLazy = (node) => {
    if (node.tagName?.toLowerCase() === 'img') {
        node.attrs = (node.attrs || []).filter(({name}) => name !== 'loading')
        node.attrs.push({name: 'loading', value: 'lazy'})
    }
}

const prepareHtmlForInjection = (html) => {
    let hasCmsModules = false
    let cmsModulesCount = 0
    if (!html) {
        return {html, hasCmsModules}
    }

    const documentFragment = parseFragment(html)

    // multi-module pages have a lot of extra content that we don't want to render immediately,
    // so wrap all except the first 2 in pwa-widget-cms to lazy load them
    documentFragment.childNodes = documentFragment.childNodes?.map((node) => {
        // example module
        // <div class="cms-page-module" data-template-id="552100290" data-template-name="spacer" data-page-module-id="408463890" rank="">
        const isCmsModule = node.attrs?.some(
            ({name, value}) => name === 'class' && value === 'cms-page-module'
        )

        if (isCmsModule) {
            hasCmsModules = true
            cmsModulesCount++
        }

        if (cmsModulesCount > 2 && isCmsModule) {
            // add loading=lazy to images in the module
            walk(node, setImageLoadingLazy)
            return {
                nodeName: 'pwa-widget-cms',
                tagName: 'pwa-widget-cms',
                namespaceURI: 'http://www.w3.org/1999/xhtml',
                attrs: [],
                childNodes: [node]
            }
        }
        return node
    })

    walk(documentFragment, (node) => {
        convertCssLinks(node)
        convertScript(node)
        convertSkImage(node)
    })

    return {
        html: serialize(documentFragment),
        hasCmsModules
    }
}

export default prepareHtmlForInjection
